import Request from '../Request.utils'
export interface IProductWebhookRequestBody {
  /**
   * Unknown Property
   */
  [x: string]: unknown;
}


class PimAPI {
  productWebhook = async (body: IProductWebhookRequestBody) => {
    const res = await Request.call('/api/pim/product-webhook', 'POST', undefined, undefined, body, );
    return res;
  }
}
export default new PimAPI()